import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedItemType = () => {
  return {
    name: null,
    image: null,
    order: null,
  };
};

export default {
  state: () => ({
    selectedItemType: getDefaultSelectedItemType(),
    ItemTypes: [],
  }),

  mutations: {
    setSelectedItemType(state, ItemType) {
      Vue.set(state, "selectedItemType", ItemType);
    },
    setItemTypes(state, ItemTypes) {
      Vue.set(state, "ItemTypes", ItemTypes);
    },
    setDefaultSelectedItemType(state) {
      Vue.set(state, "selectedItemType", getDefaultSelectedItemType());
    },
    setDefaultItemTypeModule(state) {
      Vue.set(state, "selectedItemType", getDefaultSelectedItemType());
      Vue.set(state, "ItemTypes", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createItemType: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/item-types/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadItemTypes: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-types/entity").then((response) => {
        context.commit("setItemTypes", response.data);
        return response.data;
      });
    },
    loadItemType: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-types/entity/" + request.id).then((response) => {
        context.commit("setSelectedItemType", response.data);
      });
    },
    loadPublishedItemTypes: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-types/entity/published").then((response) => {
        //TODO: Loader koyulacak
        let orderedItemTypes = response.data.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
        context.commit("setItemTypes", orderedItemTypes);
        return response.data;
      });
    },
    loadItemTypeHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/item-types/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedItemTypeHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-types/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteItemType: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-types/entity/" + item.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          item.intents = intents;
          item.intentId = response.data.id;
          return item;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftItemType: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-types/draft/" + item.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishItemType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-types/publish/" + item.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectItemType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-types/reject/" + item.intentId).then((response) => {
        if (item.intents[0].type === "DELETE_ITEM_TYPE") {
          item.intents = null;
          item.intentId = 0;
        } else if (item.intents[0].type === "CREATE_ITEM_TYPE") {
          item.intents[0].status = "DRAFT";
        } else if (item.intents[0].type === "UPDATE_ITEM_TYPE") {
          item.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalItemType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-types/sendToApproval/" + item.intentId).then((response) => {
        if (item.intents[0].type === "CREATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        } else if (item.intents[0].type === "UPDATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallItemType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-types/recall/" + item.intentId).then((response) => {
        helper.recallOrRejectEntity(item, "item_type");
        return response.data;
      });
    },
    cancelItemType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-types/cancel/" + item.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedItemType: (state) => {
      return state.selectedItemType;
    },
    getItemTypes: (state) => {
      return state.ItemTypes;
    },
  },
};
